import { render, staticRenderFns } from "./segmentosConfiguracoes.vue?vue&type=template&id=58710218&scoped=true&"
import script from "./segmentosConfiguracoes.vue?vue&type=script&lang=js&"
export * from "./segmentosConfiguracoes.vue?vue&type=script&lang=js&"
import style0 from "./segmentosConfiguracoes.vue?vue&type=style&index=0&id=58710218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58710218",
  null
  
)

export default component.exports